<template>
  <div class="varguard light-bg">
    <div class="card-header">
      <span v-if="errList.length">Vanguard</span>
      <span
        v-if="errList.length"
        class="more"
        @click.prevent="onShowDetailClick"
      >
        {{ this.draggableConfig.isShow ? '收起' : '更多' }}
      </span>
    </div>
    <div class="scroll">
      <VarguardItem :errList="this.errList" />
      <img :src="noErrorIcon" class="no-error" v-if="!errList.length" />
    </div>

    <g-drag-resize :config="draggableConfig">
      <template #default>
        <div class="detail-inner">
          <div class="close" @click="draggableConfig.isShow = false">
            <svg
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="2134"
              width="35"
              height="35"
            >
              <path
                d="M563.8 512l262.5-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z"
                p-id="2135"
                fill="#ffffff"
              ></path>
            </svg>
          </div>
          <VarguardItem :errList="this.errList" showDetail />
        </div>
      </template>
    </g-drag-resize>
  </div>
</template>

<script>
import { watch, computed, defineComponent, h } from 'vue';
import { useStore } from '@/store/index';
import moment from 'moment';
import VarguardItem from './VarguardItem.tsx';
import noErrorIcon from '@/assets/images/no-error.png';
import { useFrameDataStore } from "@/store/frameDataStore";


export default defineComponent({
  name: 'Varguard',
  data() {
    return {
      errList: [],
      moment,
      noErrorIcon,
      draggableConfig: {
        x: 0,
        y: 0,
        w: window.innerWidth - 500,
        h: 100,
        minH: 100,
        isShow: false,
        nameSpace: 'Varguard',
        customClass: 'varguard-popover',
      },
    };
  },
  components: {
    VarguardItem,
  },
  created() {
    let frameDataStore = useFrameDataStore();

    watch(
      computed(() => frameDataStore.currentData),
      (data) => {
        try {
          let abnormalInfos=data.abnormalInfos;
          const arr = JSON.parse(abnormalInfos);
          if (Array.isArray(arr)) {
            this.errList = arr;
          }
        } catch {}
      },
    );
  },
  watch: {
    $route: {
      handler() {
        this.errList = [];
      },
    },
  },
  methods: {
    onShowDetailClick(e) {
      this.draggableConfig.isShow = !this.draggableConfig.isShow;
    },
  },
});
</script>
<style scoped lang="less">
.card-header {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 16px;

  .more {
    margin-left: 16px;
    cursor: pointer;
    height: 20px;
    position: relative;
    padding-left: 13px;
    color: #3af6ff;
    font-weight: 400;

    &::after {
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 4px solid #3af6ff;
      border-right: 4px solid transparent;
      content: '';
      position: absolute;
      top: 50%;
      right: -12px;
      transform: translateY(-50%);
    }
  }
}

.varguard-popover {
  position: fixed;
  z-index: 3010 !important;
  background: url(@/assets/images/modal-bg.png) no-repeat;
  background-size: 100% 100%;
  padding: 15px 0;
  box-shadow: 0 0 16px #ccc;

  .detail-inner {
    max-height: 540px;
    width: 100%;
    height: 100%;
    overflow-x: auto;
    overflow-y: scroll;
  }

  .close {
    position: absolute;
    top: 5px;
    right: 5px;
    z-index: 22;
    cursor: pointer;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    svg {
      width: 20px;
    }
  }
}
.varguard {
  width: 470px;
  position: relative;
  overflow: hidden;
  user-select: text;
  padding: 20px 24px 0;
}

.scroll {
  max-height: 195px;
  overflow: auto;
  user-select: text;
  text-align: center;

  .no-error {
    width: 220px;
  }
}

.detail-container {
  width: 520px;
  position: fixed;
  z-index: 9;
  top: 10px;
  right: 10px;
  background-color: #000;
  user-select: text;
  background: url(@/assets/images/modal-bg.png) no-repeat;
  background-size: 100% 100%;
  padding: 19px 0;
}
</style>
